import { useState } from "react";
import { Link } from "react-router-dom";
import { Clock, Mail, MessageCircle } from "lucide-react";
import EnquiryForm from "@/components/EnquiryForm";
import Reveal from "@/components/Reveal";
import { SITE, whatsappLink } from "@/lib/site";

export default function Contact() {
  return (
    <main className="pt-24 lg:pt-32">
      <section className="mx-auto max-w-[1440px] px-4 sm:px-8 lg:px-16 py-12 lg:py-16" data-testid="contact-page">
        <Reveal>
          <p className="overline-tag">Concierge &amp; Care</p>
          <h1 className="mt-3 max-w-2xl font-display text-5xl sm:text-6xl font-semibold text-ink leading-tight">
            We&apos;re a message away
          </h1>
          <p className="mt-5 max-w-xl text-[15px] text-ink2 leading-relaxed">
            Questions on a piece, a custom commission, or care for a family heirloom — the
            Sashti concierge answers personally, usually within a few hours.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-12 lg:grid-cols-[0.85fr_1.15fr]">
          <Reveal delay={0.1}>
            <div className="space-y-8">
              <a href={whatsappLink("Hello Sashti Jewels!")} target="_blank" rel="noopener noreferrer"
                 className="group flex items-start gap-4 border border-line p-6 transition-colors hover:border-gold"
                 data-testid="contact-whatsapp-card">
                <span className="grid h-11 w-11 place-items-center border border-gold/40 text-gold"><MessageCircle size={17} /></span>
                <span>
                  <span className="block font-cinzel text-[11px] uppercase text-gold" style={{ letterSpacing: "0.22em" }}>WhatsApp the Atelier</span>
                  <span className="mt-1.5 block text-sm text-ink2">{SITE.whatsappDisplay} — fastest for photos &amp; prices</span>
                </span>
              </a>
              <a href={`mailto:${SITE.email}`} className="group flex items-start gap-4 border border-line p-6 transition-colors hover:border-gold">
                <span className="grid h-11 w-11 place-items-center border border-gold/40 text-gold"><Mail size={17} /></span>
                <span>
                  <span className="block font-cinzel text-[11px] uppercase text-gold" style={{ letterSpacing: "0.22em" }}>Write to Us</span>
                  <span className="mt-1.5 block text-sm text-ink2">{SITE.email}</span>
                </span>
              </a>
              <div className="flex items-start gap-4 border border-line p-6">
                <span className="grid h-11 w-11 place-items-center border border-gold/40 text-gold"><Clock size={17} /></span>
                <span>
                  <span className="block font-cinzel text-[11px] uppercase text-gold" style={{ letterSpacing: "0.22em" }}>Concierge Hours</span>
                  <span className="mt-1.5 block text-sm text-ink2">WhatsApp &amp; email answered 7 days a week</span>
                </span>
              </div>
              <div className="border border-gold/30 bg-bg2 p-6">
                <p className="font-display text-xl italic text-ink">“Every enquiry is read by a person — never a bot.”</p>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.18}>
            <div className="card-surface p-6 sm:p-10">
              <p className="overline-tag">Send an Enquiry</p>
              <h2 className="mt-2 mb-7 font-display text-3xl font-semibold">Tell us what you&apos;re dreaming of</h2>
              <EnquiryForm />
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
